export default __webpack_public_path__ + "static/media/886.805b96f7.gif";